module.exports = __webpack_public_path__ + "static/media/Termo_Autorizacao_Armadilha_Disseminadora.c81f2d03.pdf";